<template>
  <!-- 地址管理 -->
  <div>
    <div class="bg_gray"></div>
    <div class="addresslist">
      <headbox
        title="地址管理"
        bgColor="#39394d"
        isborder="true"
        :isbackpickup="true"
        :path="path"
      ></headbox>
       <template v-if="ishow">
       <van-empty
           class="custom-image"
           :image="require('@/assets/images/pic_no information@2x.png')"
           description="暂无数据!"
         />
      </template>
      <div class="padd" v-if="!ishow">
         <div class="whitebox" v-for="items in addresslist" :key="items.id">
        <div class="addressbox" @click="backpickup(items)">
          <div class="flex infobox">
            <div>{{ items.name }}</div>
            <div class="marginLeft">{{ items.phone }}</div>
          </div>
          <div class="adressdetails">
            {{ items.preAddr }}{{ items.address }}
          </div>
        </div>
        <!--  -->
        <div class="flex-between bottombox">
          <div></div>
          <div v-if="items.defAddr" class="abscheckbox">
            <el-checkbox
              v-model="items.defAddr"
            ></el-checkbox>
            <span>默认寄件地址</span>
          </div>
          <div v-else class="abscheckbox">
            <div
              @click="
                initdata(
                  items.id,
                  items.name,
                  items.phone,
                  items.address,
                  items.preAddr,
                  items.code
                )
              "
            >
              <el-checkbox></el-checkbox> <span> 设置为默认寄件地址</span>
            </div>
          </div>
          <div class="flex bottomboxbtn">
            <div
              class="edit"
              @click="
                editAddress(
                  items.id,
                  items.name,
                  items.phone,
                  items.address,
                  items.preAddr,
                  items.code
                )
              "
            >
              <i class="el-icon-edit-outline"></i>编辑
            </div>
            <div @click="deleteAddress(items.id)">
              <i class="el-icon-delete-solid"></i>删除
            </div>
          </div>
        </div>

        
         </div>
      </div>
      <div class="btnBox" @click="addressEdit">新增地址</div>
      <van-dialog
        v-model="deleteBox"
        show-cancel-button
        @confirm="postModel"
        @cancel="closeModel"
      >
        <div class="centerbox">确定要删除该地址吗？</div>
      </van-dialog>
    </div>
    
  </div>
</template>
<script>
import headbox from "@/components/head.vue";
import * as myaddress from "@/utils/api";

export default {
  inject: ["reload"],
  data() {
    return {
      addresslist: [],
      // 删除地址的ID
      deleteId: 0,
      deleteBox: false,
      // 上一个页面是否是上门取货
      parentpage: "",
      backperson: false,
      path:'',
      ishow:false
    };
  },
  mounted() {
    // const than = this;
    // // 判断是否从上门取货页面跳转过来
    // console.log(than.$route.query);
    this.parentpage = this.$route.query.type;
    this.path = this.$route.query.type
    if (this.parentpage == undefined || this.parentpage == "") {
      this.backperson = true;
    }
    myaddress.getAddress().then(res => {
      console.log(res);
      this.addresslist = res;
      if (this.addresslist.length ==0) {
        this.ishow = true
      }
    });
  },
  methods: {
    addressEdit(){
      this.$router.push({
        name:'addressEdit'
      })
    },
    // 设置为默认地址
    initdata(id, myname, myphone, myaddress_, mypreAddr, code) {
      const postData = {
        // 详细地址
        address: myaddress_,
        // 地区code
        code: code,
        //  是否默认地址
        defAddr: 1,
        // 地址ID
        // "id": 0,
        // 收件人名
        name: myname,
        // 收件人手机号
        phone: myphone
      };
      // 修改地址
      myaddress.edditAddress(id, postData).then(res => {
          myaddress.getAddress().then(res => {
      console.log(res);
      this.addresslist = res;
      if (this.addresslist.length ==0) {
        this.ishow = true
      }
    });
      });
    },
    // 默认地址选择
    // checkboxaddress() {},
    // 返回到上门取货的页面和买料页面
    backpickup(item) {
      console.log(item);
      console.log('parentpage',this.parentpage);
      if (this.parentpage && this.parentpage == "pickUp") {
        localStorage.setItem("address", JSON.stringify(item));
        this.$router.push({ name: "pickUp" });
      } else if (this.parentpage && this.parentpage == "claimedit") {
        localStorage.setItem("address", JSON.stringify(item));
        this.$router.push({ name: "claimedit" });
      }else if(this.$route.query.kdAddress){
        localStorage.setItem("address", JSON.stringify(item));
        this.$router.push({
          name:'purchaseOrder',
          query:{address:true}
        })
      }else if (this.parentpage && this.parentpage == "buyOrder") {
        localStorage.setItem("address", JSON.stringify(item));
        this.$router.push({ name: "buyOrder",query:{addres:'true'} });
      }
    },
    postModel() {
      myaddress.deleteAddress(this.deleteId).then(res => {
        const _this = this;
        _this.reload();
      });
    },
    closeModel() {
      console.log(2);
    },
    // 编辑地址
    // items.name,items.phone ,items.address ,items.preAddr
    editAddress(id, myname, myphone, myaddress, mypreAddr, code) {
      this.$router.push({
        name: "addressEdit",
        query: {
          type: "edit",
          Id: id,
          name: myname,
          phone: myphone,
          address: myaddress,
          preAddr: mypreAddr,
          citycode: code
        }
      });
    },
    // 删除地址
    deleteAddress(thanId) {
      this.deleteId = thanId;
      this.deleteBox = true;
    },
    selldetils() {
      this.$router.push({ name: "selldetails" });
    }
  },
  components: {
    headbox
  }
};
</script>

<style lang="scss" scoped="true">
::v-deep{
  .el-checkbox__input{
    .el-checkbox__inner{
      border-radius: 50%;
      border: 1px solid #999999 !important;
    }
  }
  .is-checked{
    .el-checkbox__inner{
      border: 1px solid  $YellowFontColor !important;
      background-color: $YellowFontColor !important;
    }
  }
}
::v-deep{ 
  .van-dialog__cancel {
  //line-height: 80px;
  //position: relative;
  //top: 20px;
  //border: none !important;
    color: $YellowFontCancelColor;
    height: 80px !important;
}
.van-dialog__message {
  font-size: 32px;
}
.van-dialog {
  width: 550px;
  padding: 0 !important;
}
.van-dialog__confirm{
  color:$YellowFontColor !important;
  height: 80px !important;
}
.van-empty__image{
        width: 420px;
        height: 260px;
}
}
.centerbox {
  font-size: 32px;
  text-align: center;
  padding: 60px 0;
  // width: 420px!important;
}
.bottomboxbtn {
  font-size: 24px;
  i {
    font-size: 30px;
    margin-right: 5px;
  }
  .edit {
    margin-right: 30px;
  }
}
.adressdetails {
  height: 50px;
  font-size: 24px;
  color:#666666;
  // margin-bottom: 15px;
}
.infobox {
  font-size: 28px;
  margin-bottom: 10px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #242424;
}
.flex{
  display: flex;
}
.bottombox {
  position: relative;
  color: #999999;
  border-top: 1px solid #E9E9E9;
  padding: 32px 30px;
  .abscheckbox {
    position: absolute;
    // left: 20px;
    // top: -5px;
  }
  span {
    position: relative;
    top: 0px;
    font-size: 20px;
    margin-left: 10px;
    display: inline-block;
    vertical-align: baseline;
  }
}

.addressbox {
  padding: 30px 30px 0;
}
.whitebox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 8px 8px 8px 8px;
}
.padd{
  padding: 20px 30px;

}
.h2 {
  margin: 15px 0 30px;
  color: #333333;
  font-size: 36px;
}
.details {
  color: #999999;
  font-size: 28px;
}
.orcodebox {
  margin: 50px auto;
  width: 400px;
  height: 360px;
}
.flex2 {
  flex: 2;
}
.titlebox {
  font-size: 36px;
  margin: 20px 0 10px;
}
.detailsbox {
  font-size: 28px;
  color: #999999;
}
.phonekefu {
  width: 50px;
  height: 50px;
}
.bg_gray {
  background: #f5f5f5;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}
.addresslist {
  position: relative;
  z-index: 1;
}
.kefubox {
  align-items: center;
  padding: 30px;
  border-radius: 12px;
  margin: 30px;
  background: #fff;
  box-shadow: 0 0 9px #ccc;
}
.headbox {
  width: 120px;
  height: 120px;
  margin-right: 30px;
}
.btnBox{
  width: 90%;
  height: 80px;
  border-radius: 80px;
  color: $YellowHeadBackgroundColor;
  font-size: 32px;
  margin: 20px auto;
  background-color: $YellowFontColor;
  line-height: 80px;
  text-align: center;
}
.marginLeft{
  margin-left: 30px;
}

</style>
